import { AnalyticsEvent } from './BaseAnalyticsEvent';
import { type AnalyticsEventName } from './types/AnalyticsEventName';

export class NotificationClickEvent extends AnalyticsEvent<AnalyticsEventName.NOTIFICATION_CLICK> {
  constructor(public data: { name: string; url: string }) {
    super(`analytics.notification_click`);
  }
}
